import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

/**
 * @param root0
 * @param root0.value
 * @param root0.className
 * @returns {JSX} RenderDateToRelativeText
 */
function RenderDateToRelativeText({ value, className = '' }) {
    if (!value) {
        return null;
    }
    const { i18n } = useTranslation();
    const lang = i18n.resolvedLanguage;
    const luxonDate = DateTime.fromISO(value, { locale: lang });

    return (
        <div className={className}>
            {
                luxonDate.toRelative()
            }
        </div>
    );
}

RenderDateToRelativeText.propTypes = {
    value: PropTypes.string,
    className: PropTypes.string
};

export default RenderDateToRelativeText;